import React, { useState, useEffect } from 'react';
import styles from './SellerSnapConsentToggle.module.css';
import { useUserContext } from '@/contexts/UserContext';
import { updateGoAuraIntegration } from '@/api/settings';
import { useErrorModalContext } from '@/contexts/ErrorModalContext';
import SellerSnapLogo from './SellerSnapLogo';

const SellerSnapConsenToggle = () => {
  const { user, setUser } = useUserContext();
  const [isActive, setIsActive] = useState(user?.sellerSnapIntegration || false);
  const [isLoading, setIsLoading] = useState(false);
  const { setErrors } = useErrorModalContext();

  // Sync component state with user data when it changes
  useEffect(() => {
    if (user) {
      setIsActive(user.sellerSnapIntegration || false);
    }
  }, [user]);

  const handleToggle = async () => {
    if (isLoading) return;
    
    try {
      setIsLoading(true);
      const newStatus = !isActive;
      
      // Optimistically update UI
      setIsActive(newStatus);
      
      await updateGoAuraIntegration({ sellerSnapIntegration: newStatus });
      setUser({ ...user, sellerSnapIntegration: newStatus }, false);
    } catch (error) {
      // Revert UI state if API call fails
      setIsActive(isActive);
      console.error('Error updating SellerSnap integration:', error);
      setErrors([{ 
        message: "Failed to update SellerSnap integration. Please try again later."
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.logoSection}>
        <div className={styles.logoContainer}>
            <SellerSnapLogo className={styles.logo} />
        </div>
        <div className={`${styles.statusBadge} ${isActive ? styles.statusActive : ''}`}>
          {isActive ? 'Active' : 'Not Active'}
        </div>
      </div>

      <div className={styles.contentSection}>
        <div className={styles.consentText}>
          I Allow the integration of my Boxem account with SellerSnap.
        </div>
        <div className={styles.dataSection}>
          <div className={styles.dataLabel}>Data Transferred:</div>
          <div className={styles.dataItem}>
            <div className={styles.dataDot}></div>
            <a href="#" className={styles.dataLink}>Buy Cost Data</a>
          </div>
        </div>
      </div>

      <div className={styles.toggleSection}>
        <div className={styles.toggleLabel}>Allow Integration</div>
        <button 
            onClick={handleToggle}
            disabled={isLoading}
            className={`${styles.toggleButton} ${isActive ? styles.toggleActive : ''}`}
            aria-label={isActive ? 'Disable SellerSnap integration' : 'Enable SellerSnap integration'}
            aria-busy={isLoading}
        >
            <span className={`${styles.toggleThumb} ${isActive ? styles.toggleThumbActive : ''}`} />
        </button>
        </div>
    </div>
  );
};

export default SellerSnapConsenToggle;